import { useDataValue } from 'Simple/Data'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let id = useDataValue({
    context: 'selected',
    path: 'event_execution_data.patient_id',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      id,
    },
    requestPolicy: 'network-only',
    pause: false,
  }
}
